import { LocationDescriptor } from 'history'
import React from 'react'
import { SectionHeaderProps } from '../../section-header/SectionHeader/SectionHeader'
import { SubHeadingElements } from '../../typography/Subhead/Subhead'
import {
    StyledHeading,
    StyledSeeAllLink,
    StyledWebLink,
} from './BauhausSectionHeader.styled'

export interface BauhausSectionHeaderProps {
    sectionHeader: SectionHeaderProps
    hasBackground?: boolean
    displaySeeAll?: boolean
    textCenter?: boolean
    specificHeaderSize?: SubHeadingElements
    borderWidth?: number
    specificFontSize?: number
}

export const BauhausSectionHeader: React.FC<BauhausSectionHeaderProps> = (
    props: BauhausSectionHeaderProps,
) => {
    const {
        sectionHeader,
        hasBackground,
        displaySeeAll,
        textCenter,
        specificHeaderSize,
        borderWidth,
        specificFontSize,
    } = props

    const StyledHeader = StyledHeading(specificHeaderSize || 'h2')

    return (
        <StyledHeader
            borderWidth={borderWidth}
            hasBackground={hasBackground}
            textCenter={textCenter}
            specificFontSize={specificFontSize}
        >
            {sectionHeader.headingUrl ? (
                <>
                    <StyledWebLink
                        to={sectionHeader.headingUrl as LocationDescriptor}
                    >
                        {sectionHeader?.heading}
                    </StyledWebLink>
                    {displaySeeAll && (
                        <StyledSeeAllLink
                            to={sectionHeader.headingUrl as LocationDescriptor}
                        >
                            <span>See All</span>
                        </StyledSeeAllLink>
                    )}
                </>
            ) : (
                sectionHeader?.heading
            )}
        </StyledHeader>
    )
}

BauhausSectionHeader.displayName = 'BauhausSectionHeader'
